module.exports = __webpack_public_path__ + "static/img/sx.592afe48.svg";